import { motion, useScroll, useSpring } from 'framer-motion'

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll()
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, restDelta: 0.001 })

  return (
    <motion.div
      className="progress-kinetic fixed top-0 left-0 right-0 z-[9999] h-[3px] origin-left"
      style={{ scaleX }}
    />
  )
}

export default ScrollProgress
